import type { VoidFunctionComponent } from 'react';

import { rejectionStatusFilterOptions } from '../../../../shared/snippets';
import { selectOptionFactory } from '../../../utils';
import { Select } from '../../generic';
import type { RejectionStatusFilterOption } from '../../../../shared/snippets';

export type Props = {
  /**
   * The initial search value.
   */
  initialValues: RejectionStatusFilterOption[];
  /**
   * Callback function to handle debounced changes to the search input.
   */
  onFilterChange: (values: RejectionStatusFilterOption[]) => void;
};

const rejectionStatusFilterLabels: Record<RejectionStatusFilterOption, string> = {
  rejected: 'Rejected',
  unrejected: 'Not Rejected',
};

const rejectionStatusFilterSelectOptions = rejectionStatusFilterOptions.map(
  (option) => selectOptionFactory(option, rejectionStatusFilterLabels[option]),
);

/**
 * This component renders a multi-select dropdown menu for filtering snippets by rejection status.
 */
const RejectionStatusFilter: VoidFunctionComponent<Props> = ({ initialValues, onFilterChange }) => {
  const values = initialValues.map((value) => selectOptionFactory(value, rejectionStatusFilterLabels[value]));
  return (
    <Select
      id="snippets-rejection-status-filter"
      isMulti
      isClearable
      placeholder="Rejection Status"
      options={rejectionStatusFilterSelectOptions}
      value={values}
      onChange={(newValues) => onFilterChange(newValues.map((option) => option.value))}
    />
  );
};

export default RejectionStatusFilter;
